import i18n from "@/plugins/i18n";

const state = {
    currentAlert: {
        displayed: false,
    },
};

const getters = {};

const mutations = {
    displayWarning(state, payload) {
      this.commit("alerts/hideAlert");
      state.currentAlert.msg = payload.msg || "";
      state.currentAlert.displayed = true;
      state.currentAlert.color = "orange darken-1";
      state.currentAlert.icon = payload.icon;
      state.currentAlert.iconGroup = payload.iconGroup;
      state.currentAlert.timeDisplayed = payload.timeDisplayed || -1;
    },
    displayError(state, payload) {
      this.commit("alerts/hideAlert");
      state.currentAlert.msg = payload.msg || "Something bad happened";
      state.currentAlert.displayed = true;
      state.currentAlert.color = "red darken-1";
      state.currentAlert.icon = payload.icon;
      state.currentAlert.iconGroup = payload.iconGroup;
      state.currentAlert.timeDisplayed = payload.timeDisplayed || -1;
    },
  displayHttpError(state, payload) {
    this.commit("alerts/hideAlert");
    let error;
    const apiError = payload.error?.response?.data;
    // tslint:disable-next-line:no-console
    console.error("### apiError : ", apiError);
    if (apiError?.error) {
      error = i18n.t(`alerts.error.${apiError.error}`);
    } else if (apiError?.name) {
      error = i18n.t(`alerts.error.${apiError.name}`);
      if (String(error).includes("alerts.error")) {
        // It means there is no generic translation for this error
        error = i18n.t(apiError.name);
      }
      if (String(error).includes(apiError.name)) {
        // It means there is no specific translation for this error
        error = apiError.name;
        if (apiError.message) {
          error += " : " + apiError.message;
        }
      }
    } else if (apiError?.message) {
      error = apiError.message;
    } else if (apiError?.errors?.length) {
      error = apiError.errors[0]?.message;
    } else if (payload.error) {
      error = payload.error;
    } else {
      error = "Something bad happened";
    }
    state.currentAlert.msg = error;
    state.currentAlert.displayed = true;
    state.currentAlert.color = "red darken-1";
    state.currentAlert.icon = payload.icon;
    state.currentAlert.iconGroup = payload.iconGroup;
    state.currentAlert.timeDisplayed = payload.timeDisplayed || -1;
  },
    displaySuccess(state, payload) {
        this.commit("alerts/hideAlert");
        state.currentAlert.msg = payload.msg || "Success";
        state.currentAlert.displayed = true;
        state.currentAlert.color = "green";
        state.currentAlert.icon = payload.icon;
        state.currentAlert.iconGroup = payload.iconGroup;
        state.currentAlert.timeDisplayed = payload.timeDisplayed || -1;
    },
    hideAlert(state) {
      state.currentAlert = {};
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
